import React from 'react';

import { getSalonPublicTemplate } from '../../../theme/salonPublicTemplates';
import AtelierMuseTemplate from './compositions/AtelierMuseTemplate';
import CercleHeritageTemplate from './compositions/CercleHeritageTemplate';
import EcrinSereinTemplate from './compositions/EcrinSereinTemplate';
import GlossLabTemplate from './compositions/GlossLabTemplate';
import HarmonieCliniqueTemplate from './compositions/HarmonieCliniqueTemplate';
import MaisonEclatTemplate from './compositions/MaisonEclatTemplate';
import NeoDermaTemplate from './compositions/NeoDermaTemplate';
import PureStudioTemplate from './compositions/PureStudioTemplate';
import SalooneSignatureTemplate from './compositions/SalooneSignatureTemplate';


const noop = () => {};

export const EMPTY_SALON_TEMPLATE_ACTIONS = Object.freeze({
  onBack: noop,
  onToggleFavorite: noop,
  onBookService: noop,
  onOpenMobileInfo: noop,
  onOpenHeaderInfo: noop,
  onOpenReviewComposer: noop,
  onOpenAllReviews: noop,
  onSelectPhoto: noop,
  onNavigatePhoto: noop,
  onSelectTeamMember: noop,
  onOpenBooking: noop,
  onContact: noop,
});

export const SALON_PUBLIC_TEMPLATE_COMPONENTS = Object.freeze({
  saloone_signature: SalooneSignatureTemplate,
  atelier_muse: AtelierMuseTemplate,
  maison_eclat: MaisonEclatTemplate,
  pure_studio: PureStudioTemplate,
  harmonie_clinique: HarmonieCliniqueTemplate,
  gloss_lab: GlossLabTemplate,
  cercle_heritage: CercleHeritageTemplate,
  ecrin_serein: EcrinSereinTemplate,
  neo_derma: NeoDermaTemplate,
});

const SalonTemplateRenderer = ({
  templateKey,
  viewModel,
  actions = EMPTY_SALON_TEMPLATE_ACTIONS,
  mode = 'public',
  viewport = 'desktop',
  direction = 'ltr',
}) => {
  const resolvedKey = getSalonPublicTemplate(templateKey).key;
  const Composition = (
    SALON_PUBLIC_TEMPLATE_COMPONENTS[resolvedKey]
    || SalooneSignatureTemplate
  );
  const resolvedMode = mode === 'preview' ? 'preview' : 'public';
  const resolvedActions = resolvedMode === 'preview'
    ? EMPTY_SALON_TEMPLATE_ACTIONS
    : { ...EMPTY_SALON_TEMPLATE_ACTIONS, ...actions };

  return (
    <Composition
      viewModel={viewModel}
      actions={resolvedActions}
      mode={resolvedMode}
      viewport={viewport}
      direction={direction}
    />
  );
};

export default SalonTemplateRenderer;
